import axios from "axios";
import { resetProfile } from "../data/redux/slices/ProfileSlice";
import { clearContactsCache } from "../data/redux/slices/ContactSlice";

let store;
export const injectStore = (_store) => {
  store = _store;
};

const baseURL ="https://nf6fp9tcn6.execute-api.eu-north-1.amazonaws.com"
  // process.env.NODE_ENV === "production"
  //   ? "https://nf6fp9tcn6.execute-api.eu-north-1.amazonaws.com"
  //   : "http://localhost:4004";


const api = axios.create({ baseURL });

api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    console.log(`[API:REQ] ${config.method?.toUpperCase()} ${config.url}`, config.data ?? "");
    return config;
  },
  (error) => {
    console.error("[API:REQ:ERR]", error.message);
    return Promise.reject(error);
  }
);
api.interceptors.response.use(
  (response) => {
    console.log(`[API:RES] ${response.status} ${response.config?.method?.toUpperCase()} ${response.config?.url}`);
    return response;
  },
  (error) => {
    const status = error.response?.status;
    const url = error.config?.url;
    const msg = error.response?.data?.message || error.message;
    console.error(`[API:ERR] ${status ?? "NETWORK"} ${error.config?.method?.toUpperCase() ?? ""} ${url ?? ""} — ${msg}`, error.response?.data ?? "");

    if (
      error.response &&
      error.response.status === 401 &&
      error.response.data.message !== "Invalid credentials" &&
      localStorage.getItem("token")
    ) {
      localStorage.removeItem("userId");
      localStorage.removeItem("token");
      if (store) {
        store.dispatch(resetProfile());
        store.dispatch(clearContactsCache());
      }

      window.location.href = "/";
    }
    return Promise.reject(error);
  }
);

export default api;
